import * as R from "ramda";
import { STRUCTURE_DIMENSIONS_PATH } from "./constants/dimensions.mjs";
import { DATAQUERY_VALUES_SEPARATOR } from "./constants/url.mjs";
import { parseDefaultAnnotation } from "./parseDefaultAnnotation.mjs";
const getDefaultSelection = (structure) => {
  const dimensionsIds = R.pipe(
    R.pathOr([], STRUCTURE_DIMENSIONS_PATH),
    R.map(R.prop("id"))
  )(structure);
  return R.pipe(
    parseDefaultAnnotation,
    R.pick(dimensionsIds),
    R.mapObjIndexed(R.split(DATAQUERY_VALUES_SEPARATOR))
  )(structure);
};
export {
  getDefaultSelection
};
